import { Component, OnInit, DestroyRef } from '@angular/core';

import { ChartDataset } from 'chart.js';
import { DashboardService } from '@app/dashboard/services/dashboard.service';
import { map } from 'rxjs/operators';
import { ToArabicPipe } from '@app/shared/pipes/toArabic.pipe';
import { CommonModule } from '@angular/common';
import { BaseChartDirective } from 'ng2-charts';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '@app/core';

@Component({
  selector: 'app-dashboard-chart3',
  templateUrl: './dashboard-chart3.component.html',
  styleUrls: ['./dashboard-chart3.component.scss'],
  standalone: true,
  imports: [CommonModule, BaseChartDirective, TranslateModule]
})
export class DashboardChart3Component implements OnInit {
  loaded: boolean;
  days = {
    Sunday: 'الأحد',
    Saturday: 'السبت',
    Friday: 'الجمعة',
    Thursday: 'الخميس',
    Wednesday: 'الاربعاء',
    Tuesday: 'الثلاثاء',
    Monday: 'الاثنين'
  };
  lineChartPlugins: any[] = [];
  minValue: number;
  maxValue: number;
  lineChartData: ChartDataset[] = [
    {
      data: [],
      label: '',
      yAxisID: 'A',
      tension: 0,
      pointHoverBackgroundColor: '#5D62B5'
    }
  ];

  lineChartLabels: string[] = [];

  lineChartOptions = {};

  lineChartColors: any[] = [
    {
      borderColor: '#5470BA',
      backgroundColor: 'transparent'
    }
  ];
  lineChartLegend = false;
  lineChartType = 'line';
  constructor(
    private service: DashboardService,
    private toArabic: ToArabicPipe,
    private languageService: LanguageService,

    private destroyRef: DestroyRef
  ) {}

  ngOnInit() {
    // this.setOptions();
    this.getData();
  }
  getData() {
    this.service
      .getData('last-week-total-weights')
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((data: any) => data.data),
        map((data: any) => this.refactorResponse(data))
      )
      .subscribe((response: any) => {
        this.lineChartLabels = response.map((data: any) => data['day']);
        this.lineChartData[0]['data'] = response.map((data: any) => data['total_weights']);
        this.loaded = true;
        // console.log(...this.lineChartData[0]['data']);
        let arr: any[] = this.lineChartData[0]['data'];
        arr = arr.map((d: any) => parseInt(d));
        this.minValue = Math.min(...arr);
        this.maxValue = Math.max(...arr);
        if (this.minValue <= 100) this.minValue = 0;
        else this.minValue = this.minValue - 100;
        this.maxValue = this.maxValue + 100;
        this.setOptions();
      });
  }
  refactorResponse = (response: any) => {
    response.forEach((element: any) => {
      element['day'] = this.days[element['day']];
    });
    return response;
  };

  setOptions() {
    return (this.lineChartOptions = {
      responsive: true,

      tooltips: {
        backgroundColor: '#5D62B5',
        titleAlign: 'center',
        titleFontSize: 16,
        titleFontFamily: 'Helvetica',
        yPadding: 0,
        xPadding: 6,
        custom: function(tooltip: any) {
          //remove tooltip body
          tooltip.body = [];
        },
        callbacks: {
          // We'll edit the `title` string
          title: (tooltipItem: any) => {
            return `
${tooltipItem[0].xLabel}

 الوزن:${this.toArabic.transform(tooltipItem[0].yLabel.toString())} طن  `;
          }
        }
      },
      //hide label dataset
      legend: {
        display: false
      },
      //change y axis to right
      scales: {
        A: {
          position: 'right',
          ticks: {
            min: this.minValue,
            max: this.maxValue
          }
        }
        // x: {
        //   ticks: {
        //     display: false
        //   }
        // }
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    });
  }
  get isEnglish(): boolean {
    return this.languageService.isEnglish;
  }
}
